export const getFunnelColorForValue = (value) => {
  if (value >= 90) return '#23B80C'; // Dark Green
  if (value >= 75) return '#6CDB29'; // Light Green
  if (value >= 50) return '#FFC700'; // Yellow
  if (value >= 25) return '#FF8A00'; // Orange
  return '#FF0000'; // Red
};
